// 📁 src/utils/textUtils.js

/**
 * Viết hoa chữ cái đầu mỗi từ (có hỗ trợ tiếng Việt)
 * @param {string} str - Chuỗi đầu vào
 * @returns {string} - Chuỗi sau khi xử lý
 */
export const toTitleCaseVietnamese = (str) => {
    return str
      .toLowerCase()
      .replace(/(^|\s)\S/g, (match) => match.toLocaleUpperCase("vi-VN"));
  };
  